import React from "react";
import notificationStore from "../../store/notification-store";
import { notificationConstant } from "../../constants/constants";
import { Link } from "react-router";


export default class AdminNotifaction extends React.Component {
    constructor() {
        super();
        this.state = {
            notificationData: notificationStore.getAll(),

        };
        this.onNotificationFetched = this.onNotificationFetched.bind(this);
    }
    onNotificationFetched() {
        this.setState({ notificationData: notificationStore.getAll() });
    }
    componentWillMount() {
        notificationStore.on(notificationConstant.FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
    }

    componentWillUnmount() {
        notificationStore.removeListener(notificationConstant.FETCHED_ALL_NOTIFICATION, this.onNotificationFetched);
    }
    onOverlayClick() {
        this.props.hide();
    }
    render() {
        return (

            <div className="notificationBox" style={{ display: this.state.notificationData.length > 0 ? "" : "none" }} >
                <div style={{
                    position: "fixed",
                    background: "transparent",
                    width: "100%", height: "100%",
                    top: "35px", left: 0, zIndex: -1
                }}
                    onClick={this.onOverlayClick.bind(this)}>
                </div>


                <div className="pointer" style={{ borderBottomColor: "#c7c7c7", top: "-11px", right: "28px" }}></div>
                <div className="pointer" style={{ borderBottomColor: "white", top: "-10px", right: "28px" }}></div>
                <div style={{
                    overflowY: "auto",
                    maxHeight: "450px",
                    maxWidth: "400px",
                    display: "flex",
                    padding: " 0 20px",
                    flexDirection: "column",
                    alignItems: "center",
                }}>
                    <ul>
                        {this.state.notificationData.map((notification, i) => {
                            return (
                                <li key={i} onClick={() => { this.props.hide(); }}>
                                    <Link to={`/permission/${notification.rowId}/${notification.tableName}`}>
                                        {notification.msg.toLowerCase()}
                                    </Link>
                                </li>
                            );
                        })}

                    </ul>
                </div>
            </div>





        );
    }

}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/admin-notifaction.jsx